import React from 'react';

import { Button } from 'scouting-ui/lib';
import { useSlate } from 'slate-react';

import type { CustomElementFormat } from './EditorTextArea.types';
import {
  isAlignType,
  isBlockActive,
  onPointerDown,
  toggleBlock,
} from './EditorTextArea.utils';
import { getIcon } from './Icon';

type BlockButtonProps = {
  format: CustomElementFormat;
};

const BlockButton = ({ format }: BlockButtonProps) => {
  const editor = useSlate();

  const isGhost = !isBlockActive(
    editor,
    format,
    isAlignType(format) ? 'align' : 'type',
  );

  return (
    <Button
      data-test-id={`block-button-${format}`}
      ghost={isGhost}
      icon={getIcon(format)}
      onClick={() => toggleBlock(editor, format)}
      onPointerDown={onPointerDown}
      size="small"
    />
  );
};

export default BlockButton;
